import { authorizedFetch } from '../../helpers/authorizedFetch'
import { formatDate } from '../../helpers/date'
import trans from '../../helpers/trans'
import { generateApiUrl } from '../../helpers/url'
import getIncluded from '../../japi/getIncluded'
import isResourceCollectionDocument from '../../japi/guards/isResourceCollectionDocument'
import { JapiDocument } from '../../japi/types/Document'
import { DateFormat } from '../../types/dateFormatTypes'
import { FetchCollectionResult, FetchResultType } from '../FetchResult'
import { UserResource } from '../User/User'
import { ShiftsCalendarUnavailableToWorkTimeSlot, ShiftsCalendarUnavailableToWorkTimeSlotResource } from './ShiftsCalendarUnavailableToWorkTimeSlot'
import { transformToShiftsCalendarUnavailableToWorkTimeSlot } from './ShiftsCalendarUnavailableToWorkTimeSlotTransformers'

export const getShiftsCalendarUnavailableToWorkTimeSlotsIndexCall = async (
    startDate: Date,
    endDate: Date,
): Promise<FetchCollectionResult<ShiftsCalendarUnavailableToWorkTimeSlot[], string>> => {
    try {
        const url = generateApiUrl({
            endpoint: '/unavailable-to-work-time-slots',
            queryParams: {
                include: 'user',
                startDate: formatDate(startDate, DateFormat.apiDateTime),
                endDate: formatDate(endDate, DateFormat.apiDateTime),
            },
        })

        const response = await authorizedFetch(url)

        const doc: JapiDocument = await response.json()

        if (! isResourceCollectionDocument<ShiftsCalendarUnavailableToWorkTimeSlotResource>(doc) || ! doc.data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const shiftsCalendarUnavailableToWorkTimeSlots = doc.data.map(shiftsCalendarUnavailableToWorkTimeSlotResource => {
            const userResource = getIncluded(doc, shiftsCalendarUnavailableToWorkTimeSlotResource, 'user') as UserResource

            return transformToShiftsCalendarUnavailableToWorkTimeSlot(shiftsCalendarUnavailableToWorkTimeSlotResource, userResource)
        })

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: shiftsCalendarUnavailableToWorkTimeSlots,
        }
    } catch (error) {
        console.error('[getShiftsCalendarUnavailableToWorkTimeSlotsIndexCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
